import { TextInput, Label } from '@nokia-csf-uxr/ccfk';
import { FieldSetContent, Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import { TextInputLabelContent } from '@nokia-csf-uxr/ccfk/TextInput';
//import React from 'react';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import ValueInput from '../../ValueInput';
import Coordinates from './Coordinates';
import getPreciseDistance from 'geolib/es/getPreciseDistance';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Form from 'react-bootstrap/esm/Form';
import WLDInputComponent from '../WLDInputComponent';
import { CONFIG } from '../../../config';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Path details component (length & sites)
 */
export default class AdvancedPathDetail extends WLDInputComponent {

    popupMap = null;

    constructor(props) {
        super(props);
    }

    /**
     * Function is called when the path lenght is changed
     * @param link  user's data
     * @param newData New data which has selected
     */
    onChange(link, newData) {
        if(link.distanceUnits.idDistUnit != newData.idDistUnit) {
            link.define("distanceUnits", newData)
            if(newData.idDistUnit == 1) { // Miles to kilometers
                link.define("site_length", (link.site_length*1.609).toFixed(2))
            } else { // Kilometers to miles
                link.define("site_length", (link.site_length/1.609).toFixed(2))
            }
        }
    }

    /**
     * Check and define the coordinate points
     * @param link Link data
     * @param element element changed
     * @param field what coordinate field
     * @param site site 1 or 2
     */
    onChangeCoords(link, element, field, site) {
        if(site == 1) {
            let newSite1Coords = {
                ...link?.site1_coords,
                [field+""]: element.target.value
            }
            link.define("site1_coords", newSite1Coords);
        } else {
            let newSite2Coords = {
                ...link?.site2_coords,
                [field+""]: element.target.value
            }
            link.define("site2_coords", newSite2Coords);
        }
        this.updateLinkLength(link);
        //this.updateRainRate(link);
    }

    /**
     * Open a popup to display the world map
     * @param {*} link 
     * @returns 
     */
    onClickToPickCoords(link) {
        if(this.popupMap != null) return;
        // Initialize the popup
        const w = 900, h = 500;

        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.innerWidth;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.innerHeight;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - 600) / 2 / systemZoom + dualScreenLeft
        const top = (height - 500) / 2 / systemZoom + dualScreenTop
        this.popupMap = window.open("/assets/map/map.html", "WLD 2 - Map",
        `
        scrollbars=yes,
        width=${w / systemZoom}, 
        height=${h / systemZoom}, 
        top=${top}, 
        left=${left}
        `
        );

        // Prepare to store the coordinates
        var site1 = {
            longitude: "0",
            longitude_direction: "",
            latitude: "0",
            latitude_direction: ""
        }

        var site2 = {
            longitude: "0",
            longitude_direction: "",
            latitude: "0",
            latitude_direction: ""
        }

        this.popupMap.addEventListener('beforeunload', () => {
            let site1Coords = this.popupMap?.document.querySelector("input[name='site1']");
            let cache = (site1Coords?.hasAttribute("longitude") ? site1Coords.getAttribute("longitude") : "0")+"";
            site1["longitude"] = cache;

            cache = (site1Coords?.hasAttribute("latitude") ? site1Coords.getAttribute("latitude") : "0")+"";
            site1["latitude"] = cache;


            let site2Coords = this.popupMap?.document.querySelector("input[name='site2']");
            cache = (site2Coords?.hasAttribute("longitude") ? site2Coords.getAttribute("longitude") : "0")+"";
            site2["longitude"] = cache;

            cache = (site2Coords?.hasAttribute("latitude") ? site2Coords.getAttribute("latitude") : "0")+"";
            site2["latitude"] = cache;
        })

        this.popupMap.sites = {
            "site1": link?.site1_coords,
            "site2": link?.site2_coords
        }

        // Check if the popup is opened
        var timer = setInterval(() => checkChild(this), 500);

        const checkChild = (pathDetailAdvanced) => {
            if (this.popupMap?.closed) {
                let convertSiteLongitude = pathDetailAdvanced.convertToDms(site1["longitude"], true);
                let convertSiteLatitude = pathDetailAdvanced.convertToDms(site1["latitude"], false);
                link.define("site1_coords", {
                    longitude: convertSiteLongitude[0].trim(), 
                    longitude_direction: convertSiteLongitude[1].trim(),
                    latitude: convertSiteLatitude[0].trim(),
                    latitude_direction: convertSiteLatitude[1].trim()
                });

                convertSiteLongitude = pathDetailAdvanced.convertToDms(site2["longitude"], true);
                convertSiteLatitude = pathDetailAdvanced.convertToDms(site2["latitude"], false);

                link.define("site2_coords", {
                    longitude: convertSiteLongitude[0].trim(), 
                    longitude_direction: convertSiteLongitude[1].trim(),
                    latitude: convertSiteLatitude[0].trim(),
                    latitude_direction: convertSiteLatitude[1].trim()
                });
                this.popupMap = null;

                this.updateLinkLength(link)

                clearInterval(timer);
            }
        }

        this.popupMap.focus();
    }

    /**
     * Convert decimal degrees to degrees minutes seconds
     * @param dd decimal degrees
     * @param isLongitude true if the dd is the latitude value 
     * @returns array with ['degrees minutes seconds', direction]
     */
    convertToDms(dd, isLongitude) {
        var dir = dd < 0
          ? isLongitude ? 'W' : 'S'
          : isLongitude ? 'E' : 'N';
      
        var absDd = Math.abs(dd);
        var deg = absDd | 0;
        var frac = absDd - deg;
        var min = (frac * 60) | 0;
        var sec = frac * 3600 - min * 60;
        // Round it to 2 decimal points.
        sec = Math.round(sec * 100) / 100;
        return [deg + " " + min + " " + sec + " ", dir];
    }

    /**
     * Format the coordinate data in right DMS format to calculte the distance
     * @param {*} site_coords object : {latitude: "0 0 0",latitude_direction: "E",longitude: "0 0 0",longitude_direction: "N" }
     * @returns 
     */
    calculteDMSDistanceFormat(site_coords) {
        let result = {};
        let cache = site_coords.latitude.split(" ");
        result["latitude"] = this.formatDMM(site_coords.latitude, site_coords.latitude_direction);
        result["longitude"] = this.formatDMM(site_coords.longitude, site_coords.longitude_direction);
        return result;
    }

    /**
     * Format coordinate in a right string
     * @param {*} coordinate DMS coordinate without ° ' or ''
     * @param {*} side N, S, W or E
     * @return transform Decimal Minutes Seconds in Decimal Minutes format
     */
    formatDMM(coordinate, side) {
        let response = coordinate.split(" ");
        return response[0]+"° "+(parseFloat(response[1])+parseFloat(response[2])/60)+"' "+side;
    }

    /**
     * Update the distance between both sites
     */
    updateLinkLength(link) {
        let site1 = this.calculteDMSDistanceFormat(link.site1_coords);
        let site2 = this.calculteDMSDistanceFormat(link.site2_coords);
        let distance = getPreciseDistance(site1, site2)/1000; // in kilometers !
        
        if(!isNaN(distance)) {
            if(link.distanceUnits?.idDistUnit == 2) {
                distance = distance/1.609
            }

            if(distance != link.site_length) {
                link.define("site_length", distance.toFixed(2));
            }
        }
    }

    /**
     * Update rain rate
     * @returns 
     */
    updateRainRate(link) {
        let formData = new FormData();

        formData.append("site1_long", link.site1_coords.longitude);
        formData.append("site1_long_side", link.site1_coords.longitude_direction);
        formData.append("site1_lat", link.site1_coords.latitude);
        formData.append("site1_lat_side", link.site1_coords.latitude_direction);
        formData.append("site2_long", link.site2_coords.longitude);
        formData.append("site2_long_side", link.site2_coords.longitude_direction);
        formData.append("site2_lat", link.site2_coords.latitude);
        formData.append("site2_lat_side", link.site2_coords.latitude_direction);
        formData.append("site_length", link.site_length);

        fetch(CONFIG.apiURI+"/link/rainrate", { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json'
            },
            body: formData
        })
        .then((res) => res.json())
        .then((json) => {
            let rainRate = json["manualRainRate"];
            link.define("rainRate", rainRate);
        })
        
    }


    render() {
        return (
            <Container>
                {this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                        <Row>
                            <Col xs={12}>
                                <button className="secondary-action-button w-100" style={{padding: "unset"}} onClick={() => this.onClickToPickCoords(link)}>
                                    <img src="/assets/icons/coord_point.svg" style={{width: "48px", height: "48px",verticalAlign: "middle"}} />
                                    <span>SELECT ON THE MAP</span>
                                </button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Label style={{marginBottom: "0"}}>Link's length<img src={"/assets/icons/restricted_access.svg"} style={{width: "24px", height: "24px", verticalAlign: "middle"}}></img></Form.Label>
                                <ValueInput disabled={link.prop_accuracy == "simple" ? false : true} valueType="float" value={link.site_length != null ? link.site_length : 1}
                                    onChange={(data) => {}}  
                                    onBlur={(data, error) => {}}></ValueInput>
                            </Col>

                            <Col xs={6}>
                                    
                                <Form.Label>Distance unit</Form.Label>
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <SingleBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { linkRef?.distanceUnits?.map((distUnit, index) =>
                                            <Form.Check
                                                type="radio"
                                                label={ distUnit.name }
                                                checked={link?.distanceUnits?.idDistUnit === distUnit.idDistUnit}
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                onChange={() => this.onChange(link, {index: index, ...distUnit}) }
                                            />
                                        ) }
                                        </>
                                    )}
                                    </SingleBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                                 
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Label>
                                    <TextInputLabelContent>Site 1</TextInputLabelContent>
                                </Label>
                                <TextInput onChange={(e) => link.define("site1", e.target.value)} value={link.site1 != null ? link.site1 : ""}></TextInput>
                            </Col>

                            <Col>
                                <Label>
                                    <TextInputLabelContent>Site 2</TextInputLabelContent>
                                </Label>
                                <TextInput onChange={(e) => link.define("site2", e.target.value)} value={link.site2 != null ? link.site2 : ""}></TextInput>
                            </Col>

                        </Row>
                        <Row>
                            <Coordinates band={1} latitude={link.site1_coords != null ? link.site1_coords.latitude : ""} latitude_direction={link.site1_coords != null ? link.site1_coords.latitude_direction : ""}
                                    longitude={link.site1_coords != null ? link.site1_coords.longitude : ""} longitude_direction={link.site1_coords != null ? link.site1_coords.longitude_direction : ""}
                                    onChangeCoords={(e, field) => { this.onChangeCoords(link, e, field, 1) }}/>
                            <Coordinates band={1} latitude={link.site2_coords != null ? link.site2_coords.latitude : ""} latitude_direction={link.site2_coords != null ? link.site2_coords.latitude_direction : ""}
                            longitude={link.site2_coords != null ? link.site2_coords.longitude : ""} longitude_direction={link.site2_coords != null ? link.site2_coords.longitude_direction : ""}
                            onChangeCoords={(e, field) => { this.onChangeCoords(link, e, field, 2) }}/>
                        </Row>


                        <div>
                            <Legend>Margin (dB)</Legend>
                            <ValueInput valueType="float" value={link.margin != null ? link.margin : 0}
                                onChange={(data) => {
                                    data = parseFloat(data);
                                    if(!Number.isNaN(data)) {
                                        link.define("margin", parseFloat(data))
                                    }
                                }}  
                                onBlur={(data, error) => {
                                    data = parseFloat(data);
                                    if(data < 0) {
                                        error(true);
                                    }
                                }}></ValueInput>
                        </div>

                    </>
                )}
                </SingleBandLinkUserContext.Consumer>
                :
                <DualBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                        <Row>
                            <Col xs={12}>
                                <button className="secondary-action-button w-100" style={{padding: "unset"}} onClick={() => this.onClickToPickCoords(link)}>
                                    <img src="/assets/icons/coord_point.svg" style={{width: "48px", height: "48px",verticalAlign: "middle"}} />
                                    <span>SELECT ON THE MAP</span>
                                </button>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Label style={{marginBottom: "0"}}>Link's length<img src={"/assets/icons/restricted_access.svg"} style={{width: "24px", height: "24px", verticalAlign: "middle"}}></img></Form.Label>
                                <ValueInput disabled={link.prop_accuracy == "simple" ? false : true} valueType="float" value={link.site_length != null ? link.site_length : 1}
                                    onChange={(data) => {}}  
                                    onBlur={(data, error) => {}}></ValueInput>
                            </Col>

                            <Col xs={6}>
                                    
                                <Form.Label>Distance unit</Form.Label>
                                <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                    <DualBandLinkReferenceContext.Consumer>
                                    {(linkRef) => (
                                        <>
                                        { linkRef?.distanceUnits?.map((distUnit, index) =>
                                            <Form.Check
                                                type="radio"
                                                label={ distUnit.name }
                                                checked={link?.distanceUnits?.idDistUnit === distUnit.idDistUnit}
                                                className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                onChange={() => this.onChange(link, {index: index, ...distUnit}) }
                                            />
                                        ) }
                                        </>
                                    )}
                                    </DualBandLinkReferenceContext.Consumer>  
                                </FieldSetContent>

                                 
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Label>
                                    <TextInputLabelContent>Site 1</TextInputLabelContent>
                                </Label>
                                <TextInput onChange={(e) => link.define("site1", e.target.value)} value={link.site1 != null ? link.site1 : ""}></TextInput>
                            </Col>

                            <Col>
                                <Label>
                                    <TextInputLabelContent>Site 2</TextInputLabelContent>
                                </Label>
                                <TextInput onChange={(e) => link.define("site2", e.target.value)} value={link.site2 != null ? link.site2 : ""}></TextInput>
                            </Col>

                        </Row>
                        <Row>
                            <Coordinates band={2} latitude={link.site1_coords != null ? link.site1_coords.latitude : ""} latitude_direction={link.site1_coords != null ? link.site1_coords.latitude_direction : ""}
                                    longitude={link.site1_coords != null ? link.site1_coords.longitude : ""} longitude_direction={link.site1_coords != null ? link.site1_coords.longitude_direction : ""}
                                    onChangeCoords={(e, field) => { this.onChangeCoords(link, e, field, 1) }}/>
                            <Coordinates band={2} latitude={link.site2_coords != null ? link.site2_coords.latitude : ""} latitude_direction={link.site2_coords != null ? link.site2_coords.latitude_direction : ""}
                            longitude={link.site2_coords != null ? link.site2_coords.longitude : ""} longitude_direction={link.site2_coords != null ? link.site2_coords.longitude_direction : ""}
                            onChangeCoords={(e, field) => { this.onChangeCoords(link, e, field, 2) }}/>
                        </Row>


                        <div>
                            <Legend>Margin (dB)</Legend>
                            <ValueInput valueType="float" value={link.margin != null ? link.margin : 0}
                                onChange={(data) => {
                                    data = parseFloat(data);
                                    if(!Number.isNaN(data)) {
                                        link.define("margin", parseFloat(data))
                                    }
                                }}  
                                onBlur={(data, error) => {
                                    data = parseFloat(data);
                                    if(data < 0) {
                                        error(true);
                                    }
                                }}></ValueInput>
                        </div>

                    </>
                )}
                </DualBandLinkUserContext.Consumer>
                }
            </Container>
        );
    }

}
